module.exports = __webpack_public_path__ + "media/Video 8.a5391402.mp4";